import React from 'react';
export function Footer() {
  return <footer className="bg-[#1F4D3A] border-t-4 border-[#C9A24B] py-10 px-4 text-center" data-id="element-137" data-mp="32wd2qgad7ltj">
      <p className="text-xs text-white/60 max-w-3xl mx-auto mb-4 leading-relaxed" data-id="element-138" data-mp="3ggtymjf7hl5r">
        Educational training-support material for bartending instructors, bar trainers, mixology educators and
        hospitality trainers. It does not replace an official bartending or responsible-service certification, or
        local laws on the sale and service of alcohol. Tastings should only be offered to students of legal drinking
        age, with responsible-service practices. Please drink responsibly. Results depend on each instructor, student
        and training context; no specific results are guaranteed.
      </p>
      <p className="text-sm text-white/80" data-id="element-139" data-mp="3qfjighqnxfon">
        © Bartending &amp; Mixology Instructor Atlas 2026 — All Rights Reserved.
      </p>
    </footer>;
}